"use strict";
angular.module('commandServiceModule', ["planCtrModalModule", "groupAssignmentDetailModule"]).
factory('commandService', ["trsHttpService", "$q", "$modal", function(trsHttpService, $q, $modal) {
    var rooturl = trsHttpService.getBigDataRootUrl();
    var wcmurl = trsHttpService.getWCMRootUrl();
    return {
        getReportList: function(id, extraparams) {
            var params = {
                "methodname": "queryDatasOfBTHZ",
                "serviceid": "mlf_report",
                TopicId: id
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        getTopicList: function(extraparams) {
            var params = {
                "methodname": "querySummaryReport",
                "serviceid": "mlf_report"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },

        getDailyscribe: function(extraparams) {
            var params = {
                "methodname": "queryTodayFeatured",
                "serviceid": "mlf_report"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        getDailyBestReport: function(id, extraparams) {
            var params = {
                "methodname": "queryDatasOfMRJX",
                "serviceid": "mlf_report",
                TopicId: id
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        getPlanTask: function(extraparams) { //额外加入task
            var params = {
                "methodname": "queryOwnerPlanTasks",
                "serviceid": "mlf_task"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        taskinvoke: function(methodname, extraparams) { //额外加入task
            var params = {
                "methodname": methodname,
                "serviceid": "mlf_task"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        getPlanInfo: function(extraparams) { //额外加入info
            var params = {
                "methodname": "queryOwnerPlanInformations",
                "serviceid": "mlf_task"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        infoinvoke: function(methodname, extraparams) { //额外加入info
            var params = {
                "methodname": methodname,
                "serviceid": "mlf_task"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        invoke: function(methodname, extraparams) {
            var params = {
                "methodname": methodname,
                "serviceid": "mlf_report"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        newInvoke: function(methodname, extraparams) {
            var params = {
                "methodname": methodname,
                "serviceid": "mlf_newreport"
            }
            params = angular.extend(params, extraparams);
            return trsHttpService.httpServer(wcmurl, params, "post");
        },
        getFileType: function(fileName) {
            var typejson = { 'jpg': 'img', 'gif': 'img', 'pdf': 'pdf', 'doc': 'word' };
            var lastfix = fileName.substr(fileName.lastIndexOf('.') + 1);
            return typejson[lastfix];
        },
        uploadMap: function() {
            return {
                "voice": ".mp3",
                "video": ".mp4,.avi,.rmvb,.flv",
                "picture": ".jpg,.png,.gif,.jpeg,.bmp"
            };
        },
        uploadType: function() {
            return {
                "voice": {
                    'extensions': 'mp3',
                    'mimetypes': 'audio/mp3'
                },
                "video": {
                    'extensions': 'mp4,flv,rmvb,avi',
                    'mimetypes': 'video/mp4,video/flv,video/rmvb,video/avi'
                },
                "picture": {
                    'extensions': 'jpg,png,gif,jpeg,bmp',
                    'mimetypes': 'image/jpg,image/png,image/gif,image/jpeg,image/bmp'
                }
            };
        },
        /**
         * [assignmentDetail description] 任务详情
         * @param  {[type]} assignmentId [description] 任务id
         * @return {[type]}              [description]
         */
        assignmentDetail: function(assignmentId) {
            var defer = $q.defer();
            var modalInstance = $modal.open({
                templateUrl: "./planningCenter/command/service/assignmentDetail/assignmentDetail_tpl.html",
                windowClass: 'assignmentDetail-window',
                backdrop: false,
                controller: "groupAssignmentDetailCtrl",
                resolve: {
                    assignmentId: function() {
                        return assignmentId;
                    }
                }
            });
            //关闭弹窗
            modalInstance.result.then(function(result) {
                defer.resolve(result);
            }, function() {
                defer.reject("cancel");
            });
            return defer.promise;
        },
    };
}]);